import { useTranslation } from "react-i18next"
import { CloseRemoveSVG, CubeCheckedSVG } from "./IconSvg"


const AddingDomainHint = () => {
  const { t } = useTranslation()

  return (
    <div className="px-2">
      <div>
        {t("DESCRIPTIONS.ADD_DOMAIN_1")}
      </div>
      <div className="d-flex justify-content-between mt-3" >
        <div className="d-flex justify-content-start " >
          <CubeCheckedSVG fill="green" />
          {t("DESCRIPTIONS.ADD_DOMAIN_2")}:
        </div>
        <div>example.com</div>
      </div>
      <div className="d-flex justify-content-between mb-3" >
        <div className="d-flex justify-content-start ">
          <CloseRemoveSVG stroke="red" />
          {t("DESCRIPTIONS.ADD_DOMAIN_3")}:
        </div>
        <div>https://www.example.com</div>
      </div>
      <div className="word-wrap-break-word">
        {t("DESCRIPTIONS.ADD_DOMAIN_4")}
      </div>
    </div>
  )
}


export default AddingDomainHint
